import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DataService {
  private isReferralFormSubmitted = new BehaviorSubject<boolean>(false);
  private currentUserSfrsUser = new BehaviorSubject<boolean>(false);
  private currentUserAdminUser = new BehaviorSubject<boolean>(false);
  private currentPartnerLoggedIn = new BehaviorSubject<boolean>(false);

  currentReferralFormStatus = this.isReferralFormSubmitted.asObservable();
  isCurrentUserSfrsUser = this.currentUserSfrsUser.asObservable();
  isCurrentUserAdminUser = this.currentUserAdminUser.asObservable();
  isCurrentPartnerLoggedIn = this.currentPartnerLoggedIn.asObservable();

  setReferralFormSubmitStatus(formSubmitted: boolean) {
    this.isReferralFormSubmitted.next(formSubmitted);
  }

  setCurrentUserAsSfrsUser(value: boolean) {
    this.currentUserSfrsUser.next(value);
  }
  setCurrentUserAsAdminUser(value: boolean) {
    this.currentUserAdminUser.next(value);
  }

  setCurrentPartnerAsLoggedIn(value: boolean) {
    this.currentPartnerLoggedIn.next(value);
  }
}
